import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'invoiceStatusColor'
})
export class InvoiceStatusColorPipe implements PipeTransform {

  transform(status: string): string {
    switch (status) {
      case 'PENDING':
        return 'text-orange-600 bg-orange-100 border-orange-200';
      case 'PENDING_CONFIRMED':
        return 'text-blue-600 bg-blue-100 border-blue-200';
      case 'SETTLED':
        return 'text-green-600 bg-green-100 border-green-200';
      case 'CANCELLED':
        return 'text-red-600 bg-red-100 border-red-200';
      default:
        return 'text-gray-600 bg-gray-100 border-gray-200';
    }
  }
}
